import './styles.sass'
import React, {Component} from 'react'

class Header extends Component
	render: ()->
		<div className="header">
			<a href="/">
				<img className="header-logo" src="/files/img/logo.svg" />
			</a>
			<div className="header-description">{@props.label}</div>
		</div>

export default Header